const fr = {
    next: 'Next',
    error: 'Erreur',
    notFound: '404 Non trouvé.',
    m: {
        loginTitle: "Déverrouillez votre Power Bank",
        phonePlaceholder: "Numéro de mobile",
        or: 'ou',
        emailLogin: 'Continuer avec l\'e-mail',
        phoneLogin: 'Continuer avec le téléphone',
        quickLogin: 'Continuer en tant qu\'invité',
        loginRequiredTip: 'Veuillez d\'abord vous connecter',
        continueGoogle: "Continuer avec Google",
        continueApple: "Continuer avec Apple",
        langBoxTitle: "Choisissez une langue",
        policyAndTerms: "Accepter les <a href='[termsOfServiceUrl]'>Conditions d'utilisation</a> et la <a href='[privacyPolicyUrl]'>Politique de confidentialité</a> de [brandName].",
        verifyTitle: 'Entrez le code à 6 chiffres envoyé au [phonenumber]',
        verifyEmailTitle: 'Entrez le code à 6 chiffres envoyé au [email]',
        paymentTitle: 'Déverrouillez votre Power Bank',
        resend: "Renvoyer le code",
        emailAddress: "Adresse e-mail",
        registerTitle: 'Entrez vos informations.',
        fNameInput: 'Prénom',
        lNameInput: 'Nom de famille',
        emailInput: 'Adresse e-mail',
        birthInput: 'Date de naissance',
        postCodeInput: 'Code postal',
        billingRate: 'Tarif',
        unpaidPopupSubtitle: "Vous avez une commande impayée",
        unpaidPopupContent: "Vous avez une commande impayée. Veuillez régler le paiement avant de louer à nouveau.",
        payNow: "Payer maintenant",
        add: "Ajouter",
        minBalanceTag: 'Min. : {amount}',
        paymentSuccessfulSubtitle: "Paiement réussi !",
        paymentSuccessfulContent: "Vous pouvez continuer votre location dès maintenant!",
        goToRental: "Aller à la location",
        repaymentTitle: "Paiement de la commande",
        rentalInformation: "Informations de location",
        selectPayMethod: 'Sélectionnez le mode de paiement',
        selectAuthorizationMethod: "Sélectionnez le mode d'autorisation",
        applePay: 'Apple Pay',
        googlePay: 'Google Pay',
        balance: 'Solde',
        creditOrDebit: 'Carte de crédit ou de débit',
        free: 'Gratuit',
        pay: 'Payer',
        confirm: 'Confirmer',
        cancel: 'Annuler',
        unlockNow: 'Déverrouiller la batterie externe',
        savePay: 'Enregistrer & Payer',
        saveRent: 'Louer',
        recharge: 'Recharger',
        balancePopupTitle: 'Recharger',
        balancePopupCurrentBalance: 'Solde actuel : {amount}',
        balancePopupMinRentBalance: 'Solde minimum pour louer : {amount}',
        topUpRent: 'Recharger',
        topUpSaveCard: 'Recharger',
        bindPopupTitle: 'Ajouter une carte de paiement',
        cardPaymentTitle: 'Paiement avec carte',
        preparingTitle: 'Préparation de votre chargeur',
        preparingSubtitle: 'Votre Power Bank est en cours d\'éjection. Veuillez patienter.',
        preparingStationBusySubtitle: 'Nous attendons la fin de l\'éjection précédente. Veuillez patienter.',
        rentalSuccessTitle: 'Succès!',
        rentalFailTitle: 'Échec!',
        rentalSuccessSubtitle: 'Merci d\'utiliser [brandName]. Veuillez retourner la Power Bank après utilisation.',
        rentalNumber: 'Numéro de location',
        rentalTime: 'Temps de location',
        rentalLocation: 'Lieu de location',
        returnTime: "Heure de retour",
        returnLocation: "Lieu de retour",
        rentalDuration: "Durée de location",
        totalAmount: "Montant Total",
        paidAmount: "Montant Payé",
        unpaidAmount: "Montant dû",
        currentFee: "Frais actuels",
        rentalInfo: 'Informations de location',
        rentingTitle: 'Vous utilisez actuellement une batterie [brandName]',
        keepIt: 'Vous souhaitez la garder ? Achetez-la maintenant !',
        findNearby: 'Trouvez facilement les stations de retour à proximité – téléchargez notre application dès maintenant !',
        nearbyStationTitle: 'Stations à proximité',
        nearbyStationSearchPlaceholder: 'Rechercher des stations de charge à proximité',
        nearbyStationRent: 'Louer',
        nearbyStationReturn: 'Retour',
        nearbyStationAvailable: 'Disponible',
        nearbyStationEmpty: 'Vide',
        nearbyStationLoading: 'Chargement des stations à proximité...',
        nearbyStationNoStations: 'Aucune station à proximité',
        nearbyStationNoRentStations: 'Aucune station de location à proximité',
        nearbyStationNoReturnStations: 'Aucune station de retour à proximité',
        nearbyStationSearchAria: 'Rechercher des stations à proximité',
        nearbyStationType: 'Type de station',
        nearbyStationDistance: 'Distance',
        scanForPowerbank: 'Scanner pour Power Bank',
        scanOtherMachine: 'Scan other machine',
        findNearbyReturnableMachines: 'Machines à retourner',
        scannedMachine: 'Scanned machine',
        scannedMachineWithCode: 'Scanned machine {code}',
        loginViewNearbyRentableMachines: 'Voir les autres machines à proximité',
        viewNearbyReturnLocations: 'Machines à retourner',
        currentMachineUnavailableHint: 'This machine is not available',
        currentMachineAvailableHint: 'La machine actuelle est prête',
        currentMachineMapDetail: 'You scanned machine {code}. Tap here to return and continue renting from this machine.',
        currentMachineMapAction: 'Tap to continue renting from this machine.',
        machineUnavailableMapDetail: 'You scanned machine {code}, but it cannot be used now. Reason: {reason}. Please scan another machine or use nearby stations on the map.',
        machineUnavailableMapAction: 'Trouvez une machine disponible à proximité et scannez son code.',
        mapIslandMachineUnavailableShort: 'Cette machine est indisponible',
        mapIslandMachineAvailableActionShort: 'Continuer sur cette machine',
        mapIslandMachineUnavailableActionShort: 'Scannez une autre machine',
        mapIslandReturnActionShort: 'Retour à la location',
        rentingMapIslandTitle: 'Location en cours',
        tapToReturnRentalPage: 'Touchez pour revenir à la location.',
        scan: 'Scanner',
        scannerHint: 'Trouvez le code QR sur la station de charge',
        flashlight: 'Lampe torche',
        mapBack: 'Retour',
        currentLocation: 'Position actuelle',
        backToMap: 'Retour à la carte',
        mapMenu: 'Menu',
        mapMenuYourInfo: 'Vos informations',
        mapMenuLanguage: 'Langue',
        mapMenuHelp: 'Aide',
        helpTitle: 'Aide',
        helpReportProblem: 'Signaler un problème',
        helpChatWithUs: 'Discuter avec nous',
        chatWithUsTitle: 'Discuter avec nous',
        chatContactMethods: 'Moyens de contact',
        reportProblemTitle: 'Signaler un problème',
        reportDeviceCode: 'Code appareil',
        reportScanQrCode: 'Scanner le QR de la machine',
        reportDeviceCodePlaceholder: 'Scannez le QR de la machine ou saisissez l’ID de l’appareil',
        reportProblemType: 'Problème',
        reportProblemTypeAria: 'Type de problème',
        reportProblemPowerBankNotEjected: 'Batterie non éjectée',
        reportProblemCannotChargeDevice: 'Ne charge pas l’appareil',
        reportProblemOrderNotEnded: 'Commande non terminée',
        reportProblemCableDamagedLost: 'Câble endommagé/perdu',
        reportProblemOther: 'Autre',
        reportTakePicture: 'Téléverser une image',
        reportChooseOrTakePicture: 'Téléverser une image',
        reportRemovePicture: 'Supprimer la photo',
        reportDescribeProblem: 'Décrire le problème',
        reportDescriptionPlaceholder: 'Veuillez saisir une description',
        reportFieldRequired: 'Obligatoire',
        reportFieldOptional: 'Optionnel',
        reportSubmit: 'Envoyer',
        reportSubmittedSuccessfully: 'Envoyé avec succès',
        mapMenuLogin: 'Se connecter',
        mapMenuLogout: 'Se déconnecter',
        mapMenuLogoutSuccess: 'Déconnecté',
        mapMenuLoadingProfile: 'Chargement du profil...',
        mapMenuLogoutConfirmTitle: 'Se déconnecter ?',
        mapMenuLogoutConfirmContent: 'Vous devrez vous reconnecter avant de louer.',
        profileTitle: 'Profil',
        profileSave: 'Enregistrer',
        profileNoChanges: 'Veuillez mettre a jour au moins un champ avec une valeur.',
        profileDeleteAccount: 'Supprimer',
        profileDeleteConfirmTitle: 'Supprimer le compte ?',
        profileDeleteConfirmContent: 'Toutes les donnees de votre compte seront supprimees definitivement et vous serez deconnecte apres la suppression.',
        closeScanner: 'Fermer le scanner',
        directions: 'Itinéraire',
        call: 'Appeler',
        cabinet: 'Station',
        addressUnavailable: 'Adresse indisponible',
        open: 'Ouvert',
        closed: 'Fermé',
        opens: 'Ouvre',
        closes: 'Ferme',
        hoursUnavailable: 'Horaires indisponibles',
        mapUnavailable: 'Carte indisponible',
        googleMapsKeyNotConfigured: 'La clé Google Maps n’est pas configurée',
        googleMapsLoadFailed: 'Échec du chargement de Google Maps',
        retry: 'Réessayer',
        mapLoading: 'Chargement de la carte...',
        mapReloading: 'Rechargement de la carte...',
        cameraUnavailable: 'La caméra n’est pas disponible dans ce navigateur',
        cameraPermissionDenied: 'L’autorisation de caméra a été refusée',
        cameraStartFailed: 'Échec du démarrage de la caméra',
        flashlightUnsupported: 'La lampe torche n’est pas prise en charge sur cet appareil',
        flashlightSwitchFailed: 'Échec du changement de lampe torche',
        invalidQrCode: 'Format de code QR invalide',
        noon: 'Midi',
        weekdayMonday: 'Lundi',
        weekdayTuesday: 'Mardi',
        weekdayWednesday: 'Mercredi',
        weekdayThursday: 'Jeudi',
        weekdayFriday: 'Vendredi',
        weekdaySaturday: 'Samedi',
        weekdaySunday: 'Dimanche',
        weekdayMon: 'Lun',
        weekdayTue: 'Mar',
        weekdayWed: 'Mer',
        weekdayThu: 'Jeu',
        weekdayFri: 'Ven',
        weekdaySat: 'Sam',
        weekdaySun: 'Dim',
        orderDeatil: 'Détails de la commande',

        subsTitle: 'Plan d\'abonnement',
        default: 'Par défaut',
        subscribeAndSave: 'Abonnement et sauvegarde',
        autoRenew: 'Renouvellement automatique',
        reachLimit: 'Limite d\'utilisation atteinte',
        paymentAuthorizationTitle: 'Autorisation de paiement',
        paymentAuthorizationRequired: 'Autorisation de paiement requise',
        paymentAuthorizationDesc1: '',
        paymentAuthorizationDesc2: 'Une autorisation est requise si la location risque de dépasser votre forfait ou si aucun moyen de paiement n’est lié pour d’éventuels frais supplémentaires.',
        paymentAuthorizationDesc3: 'Une retenue temporaire de [amount] sera effectuée. Elle sera entièrement libérée après le retour si aucun frais supplémentaire ne s’applique ; sinon, le solde restant sera remboursé après déduction des éventuels frais additionnels.',
        paymentAuthorizationDesc4: 'Veuillez sélectionner ci-dessous l’un des moyens d’autorisation pour cette location.',

        totalCost: 'Coût total',
        returnSuccessTitle: 'Retour réussi !',
        returnSuccessSubtitle: 'Merci d\'utiliser [brandName].',
        rentAgain: 'Louer à nouveau',
        guestLoginTips: 'Cette fonctionnalité nécessite un compte formel. Le mode invité n\'est pas disponible. Souhaitez-vous vous connecter ?',
        stationNotFoundTitle: "Station Not Found",
        stationNotFound: "Please try scanning the code again.",
        stationNotSetUpTitle: "Station Not Set Up",
        stationNotSetUp: "Please contact the administrator for assistance, or check other nearby stations.",
        stationOfflineTitle: "Station Offline",
        stationOffline: "Please check if the power cable is properly connected, or try unplugging and re-plugging it.",
        stationBusyTitle: "Station Busy",
        stationBusy: "The station is currently processing the rental task. Please wait a moment and try again.",
        powerBanksUnavailableTitle: "Power Banks Unavailable",
        powerBanksUnavailable: "Power banks are temporarily unavailable due to a technical issue. Please try again later or check another nearby station.",
        noPowerBanksAvailableTitle: "No Power Banks Available",
        noPowerBanksAvailable: "Please check another nearby station.",
        serverErrorTitle: "Server Error",
        serverError: "Please try again later, or contact the administrator for assistance.",
    },
    tMsg: {
        agreePolicy: `Agree to [brandName]’s Privacy Poilicy and Terms & Conditions`,
        errorTel: 'Entrer correctement le numéro de téléphone',
        sendSuccess: 'Envoyer avec succès',
        inputAll: 'Entrer toutes les informations requise',
        wrongEmail: 'E-mail incorrect',
        wrongBirthday: 'Date d’anniversaire incorrect',
        initPayFail: 'Échec du paiement initial',
        bindTimeout: 'Délai de liaison de la carte dépassé, veuillez réessayer',
        bindSuccess: 'Carte liée avec succès',
        subscriptionSuccess: 'Abonnement acheté avec succès',
        bindFailed: 'Échec de la liaison de la carte',
        paymentFailed: 'Échec du paiement',
        loginError: 'Erreur de connexion',
        paymentMethodNotSupported: 'Mode de paiement non pris en charge',
    },
    bRule: {
        priceDesc: '[price]',
        priceTimeDesc: '/[price_time] minutes',
        freeTimeDesc: '[free_time] minutes gratuites',
        flatFeeDesc: '[flat_fee] frais forfaitaires pour les premiers [flat_fee_time] minutes',
        lowLimitDesc: 'Frais minimum : [low_limit]',
        topLimitDesc: 'Frais maximum quotidien : [top_limit]',
        preAuthDesc: '[pre_auth_amount] sera préautorisé sur votre méthode de paiement',
        depositDesc: 'Si non retourné dans [maximum_rental_time] heures, [deposit] sera facturé et la power bank vous appartiendra',
        ruleError: 'Erreur de règle',
        noneRuleDesc: 'Aucune règle',
        taxIncluded: 'Taxes comprises',
        taxIncludedWithRate: 'Inclut [tax]% de taxes'
    },
    subscriptionType: {
        1: 'Gratuit [value] minutes par période d’abonnement',
        2: 'Gratuit [value] minutes par mois',
        3: 'Gratuit [value] minutes par semaine',
        4: 'Gratuit [value] minutes par jour',
        6: 'Gratuit [value] fois par période d’abonnement',
        7: 'Gratuit [value] fois par mois',
        8: 'Gratuit [value] fois par semaine',
        9: 'Gratuit [value] fois par jour',
        unlimited: 'illimité',
        unlimitedRentals: 'Locations illimitées gratuites par période d’abonnement',
        durationLimit: 'Jusqu’à [limit] minutes de location gratuite par location. Ensuite [price] par [price_time] minutes',
        maxLimit: ', maximum [top_limit] par jour',
    },
    subscriptionTitleType: {
        1: '[value] minutes par période d’abonnement',
        2: '[value] minutes par mois',
        3: '[value] minutes par semaine',
        4: '[value] minutes par jour',
        6: '[value] fois par période d’abonnement',
        7: '[value] fois par mois',
        8: '[value] fois par semaine',
        9: '[value] fois par jour',
        unlimited: 'Illimité',
        unlimitedRentals: 'Locations illimitées par période d’abonnement',
    },
    subscriptionInfo: {
        period: 'Période : [start] - [end]',
        usedShort: '([used]/[total] utilisé)',
        usage: 'Utilisation : [total] au total, [used] utilisé(s), [remaining] restant(s)',
        usageUnlimited: 'Utilisation : illimité',
        autoRenew: 'Renouvellement automatique : [value]',
        autoRenewTrue: 'Oui',
        autoRenewFalse: 'Non',
    },
    time: {
        day: 'jour | jours',
        hour: 'heure | heures',
        minute: 'minute | minutes',
        second: 'seconde | secondes',
        month: 'mois | mois',
        year: 'an | ans'
    },
    eMsg: {
        30001: 'Human verification failed',
        500: "Erreur réseau",
        1000: "Échec d’opération",
        30022: "Entrer correctement le numéro de téléphone",
        30128: "Code de vérification envoyé trop de fois. Essayer plus tard",
        30129: "Échec de l'envoi du code de vérification",
        //
        30101: 'Le code de vérification est incorrect ou a expiré',
        // 租借
        50101: "Station introuvable",
        50105: "Vous avez une commande en cours",
        50106: "La station est actuellement hors ligne",
        50108: "Il n'y a actuellement aucune batterie disponible",
        50109: "Impossible de libérer une batterie.  Veuillez réessayer",
        50113: 'Cette station nécessite un compte',
        50114: 'Les invités ne peuvent pas utiliser cette fonction. Veuillez vous connecter',
        50111: 'Mode de paiement invalide',
        50305: 'Mode de paiement invalide',
        80411: "Échec de l'ajout du mode de paiement",
        50103: 'Aucun moyen de paiement valide',
        50206: 'Le paiement de votre dernière commande a échoué. Veuillez mettre à jour votre mode de paiement',
    }
}
export default fr
